import { append, propEq, reject } from 'ramda';
import {
  type Dispatch,
  type PropsWithChildren,
  type ReactElement,
  type SetStateAction,
  useMemo,
} from 'react';

import {
  NavigationTabsContext,
  type RegisteredTarget,
} from './navigation-context';

type Props = PropsWithChildren<{
  setTargetRefs: Dispatch<SetStateAction<RegisteredTarget[]>>;
}>;

export const NavigationContextProvider = (props: Props): ReactElement => {
  const { children, setTargetRefs } = props;

  const initialContext = useMemo(
    () => ({
      register: (target: RegisteredTarget): void => {
        setTargetRefs(append(target));
      },
      unregister: (title: string): void => {
        setTargetRefs(reject(propEq('title', title)));
      },
    }),
    [setTargetRefs]
  );

  return (
    <NavigationTabsContext.Provider value={initialContext}>
      {children}
    </NavigationTabsContext.Provider>
  );
};
